import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "main-bolt",
  "use": "main-bolt-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"main-bolt\">\n    <path fill=\"#677078\" fill-rule=\"nonzero\" d=\"M12 2.02c-5.51 0-9.98 4.47-9.98 9.98 0 5.51 4.47 9.98 9.98 9.98 5.51 0 9.98-4.47 9.98-9.98 0-5.51-4.47-9.98-9.98-9.98zM11.48 20v-6.26H8L13 4v6.26h3.35L11.48 20z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol